import { useTheme } from "@emotion/react";
import "./Loader.css"; // include the CSS below

const Loader = ({ color, radius = '20px' }) => {
  const theme = useTheme();
  const finalColor = color || theme?.palette?.primary?.main;

  return (
    <div className="spinner">
      <div className="spinner-circle" style={{
        border: `2px solid ${finalColor}`,
        borderTop: '2px solid transparent',
        width: radius,
        height: radius
      }}></div>
    </div>
  );
};

export default Loader;
